define('webshopCategoriesListView',[
  'module',
  'underscore',
  'app',
  'tableView',
  'tableDatetimeFieldView',
  'webshopCategoriesListImageView',
  'webshopCategoriesListInfosView',
  'webshopCategoriesListStatusView',
  'webshopCategoriesListFiltersView',
  'webshopCategoriesListToolsView',
  'webshopCategoriesListHeaderToolsView',
  'webshopCategoriesDetailView',
  'entities/webshop/categories'
], function (
  Module,
  _,
  App,
  TableView,
  DatetimeFieldView,
  ImageView,
  InfosView,
  StatusView,
  FiltersView,
  ToolsView,
  HeaderToolsView,
  DetailView
) {
  'use strict';

  Module.exports = TableView.extend({
    className: 'webshop-categories-list-view ' + TableView.prototype.className,
    pageSize: 50,
    pageMode: 'pagination',
    filtersViewClass: FiltersView,

    setFields() {
      var fields = [];

      fields.push({
        name: 'Image',
        className: 'image',
        view: ImageView
      });

      fields.push({
        name: 'Date',
        label: _.i18n('common.date'),
        bind: 'createdAt',
        className: 'date',
        view: DatetimeFieldView
      });

      fields.push({
        name: 'Infos',
        label: _.i18n('common.category'),
        className: 'infos',
        view: InfosView
      });

      fields.push({
        name: 'Status',
        label: _.i18n('common.status'),
        className: 'status',
        view: StatusView
      });

      fields.push({
        name: 'Tools',
        className: 'tools',
        view: ToolsView,
        headerView: HeaderToolsView
      });

      return fields;
    },

    fetch: function(first, pageSize, sortField, sortDirection, filters) {
      var defer = $.Deferred();

      var params = this.getFiltersParams(filters);
      params.first = first;
      params.pageSize = pageSize;

      if(this.fetchRequest)
        this.fetchRequest.abort();

      this.fetchRequest = $.ajax({
        type: 'GET',
        url:  App.request('webshop.categories.search', params),
        success: _.bind(function (categories) {
          var models = [];

          _.each(categories, _.bind(function(item) {
            var model = App.request('webshop.category.model', item);
            models.push(model);
          }, this));

          defer.resolve(models);
        }, this)
      });

      return defer.promise();
    },

    fetchCount: function(filters) {
      var defer = $.Deferred();

      var params = this.getFiltersParams(filters);

      if(this.fetchCountRequest)
        this.fetchCountRequest.abort();

      this.fetchCountRequest = $.ajax({
        type: 'GET',
        url: App.request('webshop.categories.count', params),
        success: _.bind(function (count) {
          defer.resolve(count);
        }, this)
      });

      return defer.promise();
    },

    getFiltersParams: function(filters) {
      var params = {};

      _.each(filters.attributes, function (value, key) {
        if(key !== 'dateFrom' &&
            key !== 'dateTo') {
          if(value !== '')
            params[key] = value;
        }
      }, this);

      if(filters.get('dateFrom') !== '' && filters.get('dateTo') !== '') {
        params.dateFrom = filters.get('dateFrom');
        params.dateTo = filters.get('dateTo');
      }

      return params;
    },

    onRowDoubleClick: function(view) {
      DetailView.prototype.open(view.model.getId());
    }
  });
});
